import Ads from './ads';

export type { AdsStateEnum } from './ads';

export default Ads;
